// Complete Look Size Selector Functions
// Handles size selection popups for complete look products in both PDP and Cart Drawer

/**
 * Get all sizes for a specific color (including unavailable ones)
 */
function getAllSizesForColor(productId, selectedColor) {
  const noScriptWrapper = document.querySelector(`.product-list__noscript-wrapper-${productId}`);
  
  if (!noScriptWrapper) {
    return [];
  }
  
  const variantSelect = noScriptWrapper.querySelector(`select#Variants-${productId}`);
  
  if (!variantSelect) {
    return [];
  }
  
  const allSizes = [];

  Array.from(variantSelect.options).forEach(option => {
    if (option.text.includes(' / ')) {
      const [color, size] = option.text.split(' / ').map(str => str.trim());
      if (color === selectedColor) {
        allSizes.push({ size, variantId: option.value, available: !option.disabled });
      }
    } else {
      if (!selectedColor || selectedColor === 'default') {
        allSizes.push({ size: option.text.trim(), variantId: option.value, available: !option.disabled });
      }
    }
  });
  return allSizes;
}

/**
 * Get only available sizes for a specific color
 */
function getAvailableSizesForColor(productId, selectedColor) {
  const allSizes = getAllSizesForColor(productId, selectedColor);
  return allSizes.filter(size => size.available);
}

/**
 * Updates size selector popup options based on selected color
 */
function updateSizesForColor(productId, selectedColor) {
  const availableSizes = getAvailableSizesForColor(productId, selectedColor);

  // Update both PDP and drawer popups
  const popups = document.querySelectorAll(
    `#pdp-size-selector-popup-${productId} .size-selector-popup__options, #drawer-size-selector-popup-${productId} .size-selector-popup__options`
  );
  
  popups.forEach((sizeSelectorDiv) => {
    if (!sizeSelectorDiv) return;
    
    sizeSelectorDiv.innerHTML = ''; // Clear existing options

    // Create and append size buttons
    availableSizes.forEach(({ size, variantId }) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'size-selector-popup__option';
      button.textContent = size;
      button.setAttribute('data-variant-id', variantId);
      button.onclick = function() {
        // Show "Adding..." feedback
        const originalText = this.textContent;
        this.textContent = 'Adding...';
        this.disabled = true;
        
        // Call addToCart with button reference to restore state
        window.addToCart(variantId, productId, this, originalText);
      };
      sizeSelectorDiv.appendChild(button);
    });
  });
}

/**
 * Handle complete look swatch clicks using event delegation
 */
function handleCompleteLookSwatchClick(event) {
  const swatch = event.target.closest('.variant-swatch');
  if (!swatch) return;
  
  // Check if this swatch is inside cart-complete-look-section or complete-look-section
  const completeLookSection = swatch.closest('.cart-complete-look-section, .complete-look-section');
  if (!completeLookSection) return;
  
  // Check if this is a complete look card
  const card = swatch.closest('.card-wrapper');
  if (!card) return;
  
  const addButton = card.querySelector('.complete-look-add-button');
  if (!addButton) return;
  
  const productId = swatch.getAttribute('data-product-id');
  const selectedColor = swatch.getAttribute('data-color');
  
  if (!productId || !selectedColor) return;
  
  // Update active class
  const allSwatches = card.querySelectorAll('.variant-swatch');
  allSwatches.forEach(s => s.classList.remove('active'));
  swatch.classList.add('active');
  
  // Update product image
  const swatchElement = swatch.querySelector('.swatch');
  if (swatchElement) {
    const dataSrc = swatchElement.getAttribute('data-src');
    const dataUrl = swatchElement.getAttribute('data-url');
    const dataPrice = swatchElement.getAttribute('data-price');
    const dataSalePrice = swatchElement.getAttribute('data-sale-price');
    
    if (dataSrc && dataUrl) {
      // Find the product image and link in the card
      const productImage = card.querySelector('img');
      const productLink = card.querySelector('a.variant_dynamic_link_' + productId);
      
      if (productImage) {
        productImage.src = dataSrc;
      }
      
      if (productLink) {
        productLink.href = dataUrl;
      }
      
      // Update price if available
      if (dataPrice) {
        const priceContainer = card.querySelector('.price__container');
        if (priceContainer) {
          let priceHTML = '';
          if (dataSalePrice) {
            priceHTML = `
              <div class="price__sale">
                <span>
                  <s class="price-item price-item--regular">${dataSalePrice}</s>
                </span>
                <span class="price-item price-item--sale price-item--last">
                  ${dataPrice}
                </span>
              </div>
            `;
          } else {
            priceHTML = `
              <div class="price__regular">
                <span class="price-item price-item--regular">
                  ${dataPrice}
                </span>
              </div>
            `;
          }
          priceContainer.innerHTML = priceHTML;
        }
      }
    }
  }
  
  // Update sizes in popup if it exists (whether open or not)
  updateSizesForColor(productId, selectedColor);
}

/**
 * Initialize color swatch click handlers for complete look products
 * Uses event delegation on document body to work with dynamically added elements
 * Only needs to be called once since it uses event delegation
 */
function initializeCompleteLookSwatches() {
  // Remove any existing listener first to avoid duplicates
  document.body.removeEventListener('click', handleCompleteLookSwatchClick);
  
  // Add event listener using delegation
  // This will work for all current and future .variant-swatch elements
  document.body.addEventListener('click', handleCompleteLookSwatchClick);
}

// Initialize on page load - only needs to run once
document.addEventListener('DOMContentLoaded', function() {
  initializeCompleteLookSwatches();
});

// Make the function globally available (kept for compatibility, but not needed to be called after updates)
window.initializeCompleteLookSwatches = initializeCompleteLookSwatches;

/**
 * Opens the size selector popup for a complete look product
 * If product has only one size, directly adds to cart
 * @param {Event} event - The click event from the ADD TO BAG button
 */
window.openSizeSelector = function(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const button = event.target.closest('.complete-look-add-button');
  const card = button.closest('.card-wrapper, .card');
  const productId = button.getAttribute('data-product-id');
  
  let selectedColor = 'default';
  let availableSizes = [];

  // Get the currently selected color (if product has color options)
  const activeSwatch = card.querySelector('.variant-swatch.active');
  if (activeSwatch) {
    selectedColor = activeSwatch.getAttribute('data-color');
    availableSizes = getAvailableSizesForColor(productId, selectedColor);
  } else {
    // No color swatches found, this product might only have size options
    selectedColor = 'default';
    availableSizes = getAvailableSizesForColor(productId, 'default');
  }
  
  // Check if this product is designed to have only one size (not just one size left in stock)
  const allSizes = getAllSizesForColor(productId, selectedColor);
  
  // If product is designed with only one size total AND that size is available, add directly to cart
  if (allSizes.length === 1 && availableSizes.length === 1) {
    const buttonText = button.querySelector('span');
    const originalText = buttonText ? buttonText.textContent : 'ADD TO BAG';
    
    if (buttonText) {
      buttonText.textContent = 'Adding...';
    }
    button.disabled = true;
    
    // Add to cart directly
    window.addToCart(availableSizes[0].variantId, productId, button, originalText);
    return;
  }

  // Show popup for multiple sizes
  const popup = card.querySelector('.size-selector-popup');
  
  if (popup) {
    // Close any other open popups first
    document.querySelectorAll('.size-selector-popup.active').forEach(p => {
      if (p !== popup) p.classList.remove('active');
    });

    popup.classList.add('active');
    
    // Update sizes for the selected color
    updateSizesForColor(productId, selectedColor);
    
    // Add click outside to close
    setTimeout(() => {
      document.addEventListener('click', function closePopup(e) {
        if (!popup.contains(e.target) && !button.contains(e.target)) {
          popup.classList.remove('active');
          document.removeEventListener('click', closePopup);
        }
      });
    }, 10);
  }
};

/**
 * Get variant price data from select option to check if on sale (Complete Look)
 * @param {string} productId - The product ID
 * @param {string} variantId - The variant ID
 * @returns {Object|null} Object with price and compareAtPrice, or null if not found
 */
function findCompleteLookVariantPrices(productId, variantId) {
  const noScriptInputWrapper = document.createElement('div');
  noScriptInputWrapper.innerHTML = document.querySelector(`.product-list__noscript-wrapper-${productId}`).innerHTML;
  const variantSelect = noScriptInputWrapper.querySelector(`select#Variants-${productId}`);
  if (!variantSelect) return null;

  const option = variantSelect.querySelector(`option[value="${variantId}"]`);
  if (!option) return null;
  const priceAttr = option.getAttribute('data-price');
  const compareAtPriceAttr = option.getAttribute('data-compare-at-price');
  
  const price = priceAttr ? parseFloat(priceAttr) : null;
  const compareAtPrice = compareAtPriceAttr && compareAtPriceAttr !== '' ? parseFloat(compareAtPriceAttr) : null;

  return {
    price: price,
    compareAtPrice: compareAtPrice
  };
}

/**
 * Adds a variant to the cart and updates the cart drawer
 * @param {string} variantId - The variant ID to add to cart
 * @param {string} productId - The product ID (used to close the correct popup)
 * @param {HTMLElement} button - Optional button element to restore text
 * @param {string} originalText - Original button text to restore
 */
window.addToCart = function(variantId, productId, button, originalText) {
  // Get variant price data from select option to check if on sale
  let properties = {};
  if (AFTERSHIP_PROPERTIES && AFTERSHIP_PROPERTIES.ENABLE_FINAL_SALE_PROPERTY) {
    const variantPrices = findCompleteLookVariantPrices(productId, variantId);
    if (variantPrices && variantPrices.compareAtPrice && variantPrices.price && variantPrices.compareAtPrice > variantPrices.price) {
      properties[AFTERSHIP_PROPERTIES.FINAL_SALE_KEY] = AFTERSHIP_PROPERTIES.FINAL_SALE_VALUE;
    }
  }

  const cartData = {
    id: variantId,
    quantity: 1
  };

  // Add properties if variant is on sale
  if (Object.keys(properties).length > 0) {
    cartData.properties = properties;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(cartData),
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    // Store the latest added variant ID
    localStorage.setItem('latestAddedVariantId', variantId);
    
    // Hide empty cart drawer message
    if (typeof $ !== 'undefined') {
      $('.drawer__inner-empty').hide();
    } 
    
    // Close the size selector popup - check both PDP and drawer contexts
    const pdpPopup = document.querySelector(`#pdp-size-selector-popup-${productId}`);
    const drawerPopup = document.querySelector(`#drawer-size-selector-popup-${productId}`);
    if (pdpPopup) pdpPopup.classList.remove('active');
    if (drawerPopup) drawerPopup.classList.remove('active');
    
    // Restore original button text and re-enable if provided
    if (button) {
      button.disabled = false;
      if (originalText) {
        // Check if button has a span (ADD TO BAG button) or is direct text (size button)
        const buttonText = button.querySelector('span');
        if (buttonText) {
          buttonText.textContent = originalText;
        } else {
          button.textContent = originalText;
        }
      }
    }
    
    // Open cart drawer if not already open
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && !cartDrawer.classList.contains('active')) {
      cartDrawer.classList.add('drawer', 'animate', 'active');
      cartDrawer.classList.remove('is-empty');
      document.body.classList.add('overflow-hidden');
    }
    
    // Update cart drawer content with fresh server-rendered complete look section
    fetch(`${window.Shopify?.routes?.root || '/'}cart?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer', '.shipping-progress-container', '.cart-drawer__recommendations'];
        
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          
          if (targetElement && sourceElement) {
            // Both exist: replace target with source
            targetElement.replaceWith(sourceElement);
          } else if (targetElement && !sourceElement) {
            // Target exists but source doesn't (e.g., shipping progress when cart becomes empty): remove target
            targetElement.remove();
          } else if (!targetElement && sourceElement) {
            // Source exists but target doesn't (e.g., shipping progress when cart gets first item): add source
            if (selector === '.shipping-progress-container') {
              // Insert shipping progress before cart-drawer-items
              const cartDrawerItems = document.querySelector('cart-drawer-items');
              if (cartDrawerItems) {
                cartDrawerItems.parentNode.insertBefore(sourceElement, cartDrawerItems);
              }
            } else if (selector === '.cart-drawer__recommendations') {
              // Insert recommendations AFTER drawer__footer
              const drawerFooter = document.querySelector('.drawer__footer');
              if (drawerFooter) {
                drawerFooter.parentNode.insertBefore(sourceElement, drawerFooter.nextSibling);
              } else {
                // Fallback: insert at the end of drawer__contents-wrapper
                const contentsWrapper = document.querySelector('.drawer__contents-wrapper');
                if (contentsWrapper) {
                  contentsWrapper.appendChild(sourceElement);
                }
              }
            } else {
              // For other selectors, insert before cart-drawer-items
              const insertBeforeElement = document.querySelector('cart-drawer-items');
              if (insertBeforeElement) {
                insertBeforeElement.parentNode.insertBefore(sourceElement, insertBeforeElement);
              }
            }
          }
        }
        
        // Trigger event to reinitialize cart recommendations functionality
        // Fetch cart data to pass to the event
        fetch('/cart.js')
          .then(response => response.json())
          .then(cartData => {
            document.dispatchEvent(new CustomEvent('cartRecommendationsUpdated', { detail: cartData }));
          })
          .catch(() => {
            // Fallback without cart data
            document.dispatchEvent(new CustomEvent('cartRecommendationsUpdated'));
          });
        
        // No need to reinitialize - event delegation on body handles dynamic elements

        // Scroll to CartDrawer-CartItems
        setTimeout(() => {
          const cartItemsElement = document.getElementById('CartDrawer-CartItems');
          if (cartItemsElement) {
            cartItemsElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);

      })
      .catch(error => {
        console.error('Error updating cart drawer:', error);
      });
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    // Restore original button text and re-enable on error
    if (button) {
      button.disabled = false;
      if (originalText) {
        // Check if button has a span (ADD TO BAG button) or is direct text (size button)
        const buttonText = button.querySelector('span');
        if (buttonText) {
          buttonText.textContent = originalText;
        } else {
          button.textContent = originalText;
        }
      }
    }
  });
};

